import ApiService from '../common/api.service';

import {
  CREATE_REGLAMENTO,
  FETCH_REGLAMENTOS,
  OBTENER_ARCHIVO_REGLAMENTO,
  REMOVE_REGLAMENTO,

} from './actions.type';

import {
  SET_ERROR,
  CLEAR_ALERT_DIALOG,
} from './mutations.type';


/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */

const state = {
  alert: false,
  alertMessage: '',
  alertType: 'success',
};

const getters = {
  alertContainer(state) {
    return state.alert;
  },
  alertContainerMessage(state) {
    return state.alertMessage;
  },
  alertContainerType(state) {
    return state.alertType;
  },
};

const actions = {
  [FETCH_REGLAMENTOS](context, data) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.post('accesos/listar_reglamentos', data)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
        });
    });
  },
  [OBTENER_ARCHIVO_REGLAMENTO](context, fileName) {
    return new Promise((resolve, reject) => {
      ApiService.setHeader();
      ApiService.blob(`accesos/reglamento_file/${fileName}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
          context.commit(SET_ERROR, [response.data.message]);
        });
    });
  },
  [REMOVE_REGLAMENTO](context, reglamentoId) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.post(`accesos/remove_reglamento/${reglamentoId}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ data }) => {
          context.commit(SET_ERROR, [data.data.message]);
        });
    });
  },
  [CREATE_REGLAMENTO](context, data) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.post('accesos/agregar_reglamento', data)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
        });
    });
  },
};

const mutations = {
  [SET_ERROR](state, data) {
    state.alert = true;
    state.alertMessage = data;
    state.alertType = 'error';
  },
  [CLEAR_ALERT_DIALOG](state) {
    state.alert = false;
    state.alertMessage = '';
    state.alertType = 'success';
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
